<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="toc">Table of Contents</h1>
<p class="toc"><a href="#/OEBPS/9780795338557_epub_epi_r1.htm">Epigraph</a></p>
<p class="toc"><a href="#/OEBPS/9780795338557_epub_map_r1.htm">Family Tree</a></p>
<p class="toc2"><a href="#/OEBPS/9780795338557_epub_p01_r1.htm">Book One: Matriarch</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c01_r1.htm">Chapter 1</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c02_r1.htm">Chapter 2</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c03_r1.htm">Chapter 3</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c04_r1.htm">Chapter 4</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c05_r1.htm">Chapter 5</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c06_r1.htm">Chapter 6</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c07_r1.htm">Chapter 7</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c08_r1.htm">Chapter 8</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c09_r1.htm">Chapter 9</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c10_r1.htm">Chapter 10</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c11_r1.htm">Chapter 11</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c12_r1.htm">Chapter 12</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c13_r1.htm">Chapter 13</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c14_r1.htm">Chapter 14</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c15_r1.htm">Chapter 15</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c16_r1.htm">Chapter 16</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c17_r1.htm">Chapter 17</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c18_r1.htm">Chapter 18</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c19_r1.htm">Chapter 19</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c20_r1.htm">Chapter 20</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c21_r1.htm">Chapter 21</a></p>
<p class="toc2"><a href="#/OEBPS/9780795338557_epub_p02_r1.htm">Book Two: Heiress</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c22_r1.htm">Chapter 22</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c23_r1.htm">Chapter 23</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c24_r1.htm">Chapter 24</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c25_r1.htm">Chapter 25</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c26_r1.htm">Chapter 26</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c27_r1.htm">Chapter 27</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c28_r1.htm">Chapter 28</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c29_r1.htm">Chapter 29</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c30_r1.htm">Chapter 30</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c31_r1.htm">Chapter 31</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c32_r1.htm">Chapter 32</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c33_r1.htm">Chapter 33</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c34_r1.htm">Chapter 34</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c35_r1.htm">Chapter 35</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c36_r1.htm">Chapter 36</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c37_r1.htm">Chapter 37</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c38_r1.htm">Chapter 38</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c39_r1.htm">Chapter 39</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c40_r1.htm">Chapter 40</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c41_r1.htm">Chapter 41</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c42_r1.htm">Chapter 42</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c43_r1.htm">Chapter 43</a></p>
<p class="toc2"><a href="#/OEBPS/9780795338557_epub_p03_r1.htm">Book Three: Tycoon</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c44_r1.htm">Chapter 44</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c45_r1.htm">Chapter 45</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c46_r1.htm">Chapter 46</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c47_r1.htm">Chapter 47</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c48_r1.htm">Chapter 48</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c49_r1.htm">Chapter 49</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c50_r1.htm">Chapter 50</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c51_r1.htm">Chapter 51</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c52_r1.htm">Chapter 52</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c53_r1.htm">Chapter 53</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c54_r1.htm">Chapter 54</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c55_r1.htm">Chapter 55</a></p>
<p class="toc1"><a href="#/OEBPS/9780795338557_epub_c56_r1.htm">Chapter 56</a></p>
<p class="toc"><a href="#/OEBPS/9780795338557_epub_bm1A_r1.htm">An Excerpt from A Woman of Substance</a></p>
<p class="toc"><a href="#/OEBPS/9780795338557_epub_bm1_r1.htm">Other Barbara Taylor Bradford titles from RosettaBooks</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795338557_epub_toc_r1.vue?6a7791c2